/**
 * Validates if an email address has a valid format.
 *
 * Uses a comprehensive regex pattern that supports Unicode characters
 * and follows RFC-compliant email validation rules.
 *
 * @param email - The email address string to validate
 * @returns True if the email has a valid format, false otherwise
 *
 * @example
 * ```typescript
 * validateEmail('user@example.com') // returns true
 * validateEmail('invalid-email') // returns false
 * validateEmail('') // returns false
 * ```
 */
export function validateEmail(email: string): boolean {
  // taken from validate.js
  // https://github.com/ansman/validate.js/blob/04b727223ed7d54f65a6de4897f0e460e7f6c735/validate.js#L1049
  const re =
    // eslint-disable-next-line no-useless-escape
    /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
  return email !== '' && re.test(email)
}
